import { render } from "./DelimiterTagInput.vue?vue&type=template&id=042b0742&scoped=true"
import script from "./DelimiterTagInput.vue?vue&type=script&lang=js"
export * from "./DelimiterTagInput.vue?vue&type=script&lang=js"

import "./DelimiterTagInput.vue?vue&type=style&index=0&id=042b0742&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042b0742"]])

export default __exports__